// API utility for making authenticated requests with Bearer token

export const apiCall = async (endpoint, options = {}) => {
  const token = localStorage.getItem('token');
  
  const headers = {
    ...options.headers,
  };
  
  // Add Authorization header if token exists
  if (token) {
    headers['Authorization'] = `Bearer ${token}`;
  }
  
  // Don't set Content-Type for FormData - browser sets it automatically with boundary
  // Remove Content-Type if it exists and body is FormData
  if (options.body instanceof FormData && headers['Content-Type']) {
    delete headers['Content-Type'];
  }
  
  const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}${endpoint}`, {
    ...options,
    headers,
  });
  
  // If 401, token might be expired - clear it
  if (response.status === 401) {
    localStorage.removeItem('token');
    // Optionally redirect to login
    if (window.location.pathname !== '/login' && window.location.pathname !== '/') {
      window.location.href = '/login';
    }
  }
  
  return response;
};

// Helper for authenticated fetch with credentials (for backward compatibility)
export const authenticatedFetch = (endpoint, options = {}) => {
  return apiCall(endpoint, options);
};
